var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"order-card-select",attrs:{"title":_vm.option.name,"img-src":_vm.option.image_path,"img-alt":_vm.option.name,"img-bottom":""},on:{"click":function($event){return _vm.emitCardChoice(_vm.option.id)}}})}
var staticRenderFns = []

export { render, staticRenderFns }